import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const themeCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:contents}";

const Theme = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.name = '';
  }
  render() {
    return (h(Host, { class: `sl-theme-${this.name}` }, h("slot", null)));
  }
  static get style() { return themeCss; }
}, [1, "sl-theme", {
    "name": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["sl-theme"];
  components.forEach(tagName => { switch (tagName) {
    case "sl-theme":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Theme);
      }
      break;
  } });
}

const SlTheme = Theme;
const defineCustomElement = defineCustomElement$1;

export { SlTheme, defineCustomElement };
